<template>
  <v-container fluid>
    <div v-if="!hideMainTable">
      <v-row>
        <v-col cols="12">
          <MolecularMarkerTable
            :hideSelectionTable="false"
            :hideValidations="true"
            @nextValidations="hideMainTable = true"
            @openOligo="(showOligoHistory = true), (hideMainTable = true)"
          />
        </v-col>
      </v-row>
    </div>
    <div v-if="showValidations">
      <Validation
        @hide_validations="(showOligoHistory = true), (showValidations = false)"
      ></Validation>
    </div>
    <div
      v-if="showOligoHistory"
      @close_and_open_form="
        (showUpdateOligoFormModal = true), (showOligoHistoryModal = false)
      "
    >
      <oligo-history-table
        @hide_table="(hideMainTable = false), (showOligoHistory = false)"
        @open_validations="(showValidations = true), (showOligoHistory = false)"
      />
    </div>
  </v-container>
</template>

<script>
import Validation from "@/components/validations/Validation.vue";
import OligoHistoryTable from "@/components/validations/OligoHistoryTable.vue";
import MolecularMarkerTable from "@/components/cmda_admin/MolecularMarkerTable.vue";
export default {
  components: {
    Validation,
    OligoHistoryTable,
    MolecularMarkerTable,
  },
  data: () => ({
    hideMainTable: false,
    showValidations: false,
    showOligoHistory: false,
  }),
};
</script>

<style></style>
